<template>
  <div class="ccui-app-container">
    <!--主体部分-->
    <div class="ccui-advanced-search-wrapper ccui-clearfix bottom-mar">
      <div class="ccui-tab-wrapper">
        <div class="ccui-app-container-detail-body rel">
          <el-tabs
            v-model="activeName"
            class="el-tabs__customize dic-sub-tabs-style01"
          >
            <el-tab-pane label="手机号变更" name="tab01">
              <div class="openStep">
                <div class="one">
                  <div class="circle check_circle">
                    <div class="circle1">1</div>
                  </div>
                  <span :class="check_page >= 0 ? ' check_stepTxt' : 'stepTxt'"
                    >身份认证</span
                  >
                </div>
                <span class="circleSmall circleSmall1"></span>
                <span class="circleSmall circleSmall2"></span>
                <span class="circleSmall circleSmall3"></span>
                <div class="two">
                  <div
                    :class="check_page >= 1 ? 'circle check_circle' : 'circle'"
                  >
                    <div class="circle1">2</div>
                  </div>
                  <span :class="check_page >= 1 ? ' check_stepTxt' : 'stepTxt'"
                    >变更手机号</span
                  >
                </div>
                <span class="circleSmall circleSmall1"></span>
                <span class="circleSmall circleSmall2"></span>
                <span class="circleSmall circleSmall3"></span>
                <div class="three">
                  <div
                    :class="check_page >= 2 ? 'circle check_circle' : 'circle'"
                  >
                    <div class="circle1">3</div>
                  </div>
                  <span :class="check_page >= 2 ? ' check_stepTxt' : 'stepTxt'"
                    >完成</span
                  >
                </div>
              </div>

              <el-row v-if="check_page === 0" style="padding-left: 120px">
                <el-col :span="24">
                  <div class="tips">使用手机短信验证码完成身份认证</div>
                </el-col>

                <el-col :span="24" class="row1">
                  <span class="labe">当前手机号：</span>
                  <el-input
                    class="myInput"
                    v-model="formData.mobileNum"
                    disabled
                  ></el-input>
                </el-col>
                <el-col :span="24" class="row1">
                  <span class="labe">手机验证码：</span>
                  <el-input
                    class="myInput"
                    v-model="pwdForm.code"
                    placeholder="请输入手机验证码"
                  ></el-input>
                  <el-button
                    size="mini"
                    :disabled="disabled"
                    @click="sendVerification(1)"
                    class="mybtn1"
                    type="default-mini"
                  >
                    <template v-if="!disabled"
                      ><i class="icon-ccui-envelope"></i>
                      获取短信验证码</template
                    >
                    <template v-else>
                      {{ count > 0 ? count + "秒" : "" }}
                    </template>
                  </el-button>
                </el-col>

                <el-col :span="24">
                  <el-button
                    class="mybtn"
                    size="small"
                    type="primary"
                    @click="editPwd(1)"
                    >提交验证</el-button
                  >
                </el-col>

                <el-col
                  style="margin: 20px 0; display: flex; align-items: flex-start"
                  :span="24"
                >
                  <el-image
                    style="
                      width: 18px;
                      height: 16px;
                      margin-right: 10px;
                      margin-top: 4px;
                    "
                    :src="i2"
                    fit="cover"
                  ></el-image>
                  收不到短信验证码？
                </el-col>

                <el-col
                  style="
                    width: 420px;
                    color: rgb(148, 148, 148);
                    font-size: 14px;
                    display: flex;
                    align-items: flex-start;
                  "
                  :span="24"
                >
                  <el-image
                    style="
                      width: 20px;
                      height: 19px;
                      margin-right: 10px;
                      margin-top: 1px;
                    "
                    :src="i1"
                    fit="cover"
                  ></el-image>
                  <div class="flex:1;">
                    请检查手机网络并核实手机是否屏敞系统短信，如均正常请重新获取或稍后再试。
                  </div>
                </el-col>
              </el-row>

              <el-row v-if="check_page === 1" style="padding-left: 120px">
                <!-- <el-col :span="24">
                  <div class="tips">使用手机短信验证码完成身份认证</div>
                </el-col> -->

                <el-col :span="24" class="row1">
                  <span class="labe">变更手机号：</span>
                  <el-input
                    class="myInput"
                    v-model="pwdForm.mobileNum"
                  ></el-input>
                </el-col>
                <el-col :span="24" class="row1">
                  <span class="labe">手机验证码：</span>
                  <el-input
                    class="myInput"
                    v-model="pwdForm.newCode"
                    placeholder="请输入手机验证码"
                  ></el-input>
                  <el-button
                    size="mini"
                    :disabled="disabled"
                    @click="sendVerification(2)"
                    class="mybtn1"
                    type="default-mini"
                  >
                    <template v-if="!disabled"
                      ><i class="icon-ccui-envelope"></i>
                      获取短信验证码</template
                    >
                    <template v-else>
                      {{ count > 0 ? count + "秒" : "" }}
                    </template>
                  </el-button>
                </el-col>

                <el-col :span="24">
                  <el-button
                    class="mybtn"
                    size="small"
                    type="primary"
                    @click="editPwd(2)"
                    >提交验证</el-button
                  >
                </el-col>

                <el-col
                  style="margin: 20px 0; display: flex; align-items: flex-start"
                  :span="24"
                >
                  <el-image
                    style="
                      width: 18px;
                      height: 16px;
                      margin-right: 10px;
                      margin-top: 4px;
                    "
                    :src="i2"
                    fit="cover"
                  ></el-image>
                  收不到短信验证码？
                </el-col>

                <el-col
                  style="
                    width: 420px;
                    color: rgb(148, 148, 148);
                    font-size: 14px;
                    display: flex;
                    align-items: flex-start;
                  "
                  :span="24"
                >
                  <el-image
                    style="
                      width: 20px;
                      height: 19px;
                      margin-right: 10px;
                      margin-top: 1px;
                    "
                    :src="i1"
                    fit="cover"
                  ></el-image>
                  <div class="flex:1;">
                    请检查手机网络并核实手机是否屏敞系统短信，如均正常请重新获取或稍后再试。
                  </div>
                </el-col>
              </el-row>

              <el-row v-else-if="check_page === 2" style="padding-left: 120px">
                <div class="registerBox">
                  <h1>
                    <div class="box">
                      <i
                        style="
                          color: rgb(255, 255, 255);
                          font-weight: 600;
                          font-size: 46px;
                          position: relative;
                          top: 10px;
                        "
                        class="el-icon-check"
                      ></i>
                    </div>
                    您的手机号变更已完成，（<span style="color: #ff142f">{{
                      count > 0 ? count + "秒" : ""
                    }}</span
                    >）秒后将退出登录！
                  </h1>
                </div>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  changeExternalExpertMobile,
  sendExtExpChangeMobileVerCode,
  getExternalExpertDetail
} from "@/app/sourceManage/api/expert";
import Cookies from "js-cookie";

import { addUrlPerFix } from "@/basa/utils";

export default {
  name: "changePasswordEdit",
  components: {},
  data() {
    return {
      i1: require("./image/1.png"),
      i2: require("./image/2.png"),
      submitAssignmentList: [],
      checked: false,
      count: "",
      timer: "",
      actives: 1,
      disabled: false,
      check_page: 0,
      requestSeachParams: {
        searchName: ""
      },
      purchaseInstitutionNameSelectedNode: [], //确认选择的采购人数据
      professionList: [],
      isShow: false,
      purchaseInstitutionNamePartyId: 100002, //单位采购的父级Id
      // 选择组织单位弹窗
      activeName: "tab01",
      manageDirection: [],
      formData: {},
      manageDirectionOptions: [], //管理方向
      certificateOptions: [],
      fieldOptions: [],
      postTitleOptions: [], //职称
      academicOptions: [], //学历
      nationOptions: [], //民族
      sexOptions: [], //性别
      manageDeptTreeProps: {
        label: "name",
        isLeaf: "isLeaf"
      },
      pwdForm: {
        mobileNum: "",
        code: "",
        newCode: ""
      },
      type: "",
      upExpertId: "",
      expertId: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    editPwd(type) {
      if (type === 1) {
        // 验证当前手机号
        if (!this.pwdForm.code) {
          this.$message({
            message: "请输入手机验证码",
            type: "error",
            duration: 3000,
            ccuiCustom: true,
            showClose: true,
            offset: document.body.clientHeight / 2 - 21
          });
          return false;
        }
        // 提交验证码接口
        changeExternalExpertMobile({
          mobileNum: this.formData.mobileNum,
          changeMobileFlag: 1,
          verificationCode: this.pwdForm.code,
          isShowLoading: true
        }).then(res => {
          if (res.data.code === "0") {
            this.disabled = false;
            this.count = "";
            clearInterval(this.timer);
            this.check_page++;
          }
        });
      } else {
        // 验证变更手机号
        if (!this.pwdForm.mobileNum) {
          this.$message({
            message: "请输入变更手机号",
            type: "error",
            duration: 3000,
            ccuiCustom: true,
            showClose: true,
            offset: document.body.clientHeight / 2 - 21
          });
          return false;
        }
        if (!this.pwdForm.newCode) {
          this.$message({
            message: "请输入验证码",
            type: "error",
            duration: 3000,
            ccuiCustom: true,
            showClose: true,
            offset: document.body.clientHeight / 2 - 21
          });
          return false;
        }
        // 提交验证码接口
        changeExternalExpertMobile({
          mobileNum: this.pwdForm.mobileNum,
          changeMobileFlag: 2,
          verificationCode: this.pwdForm.newCode,
          isShowLoading: true
        }).then(res => {
          if (res.data.code === "0") {
            this.disabled = false;
            this.count = "";
            clearInterval(this.timer);
            let that = this;
            that.check_page++;
            that.count = 5;
            that.timer = setInterval(() => {
              that.count--;
              if (that.count === 0) {
                clearInterval(that.timer);
                localStorage.setItem("userInfo", "");
                localStorage.setItem("appToken", "");
                localStorage.setItem("loginInfo", "");
                Cookies.remove("access_token", {
                  path: "/",
                  domain: "iccec.cn"
                });
                window.location.href = addUrlPerFix(process.env.EVA_APP_LOGIN);
                //  +
                // "?redirectUrl=" +
                // encodeURIComponent(window.location.href);
              }
            }, 1000);
          }
        });
      }
    },
    init() {
      let params = {
        isCurrent: 1,
        isTakeEffect: 0,
        isShowPageLoading: true
      };

      getExternalExpertDetail(params).then(res => {
        if (res.data.code === "0") {
          this.formData = {
            ...res.data.data.sscExpertManageUnit,
            ...res.data.data.expertDetailBO
          };
        }
      });
    },

    sendVerification(type) {
      if (type === 1) {
        sendExtExpChangeMobileVerCode({
          phoneNumbers: this.formData.mobileNum,
          isShowLoading: true
        }).then(res => {
          if (res.data.code === "0") {
            this.disabled = true;
            this.count = 60;
            this.timer = setInterval(() => {
              this.count--;
              if (this.count === 0) {
                this.disabled = false;
                this.count = "";
                clearInterval(this.timer);
              }
            }, 1000);
          }
        });
      } else {
        if (!this.pwdForm.mobileNum) {
          this.$message({
            message: "请先输入变更手机号",
            type: "error",
            duration: 3000,
            ccuiCustom: true,
            showClose: true,
            offset: document.body.clientHeight / 2 - 21
          });
          return false;
        }
        sendExtExpChangeMobileVerCode({
          phoneNumbers: this.pwdForm.mobileNum,
          isShowLoading: true
        }).then(res => {
          if (res.data.code === "0") {
            this.disabled = true;
            this.count = 60;
            this.timer = setInterval(() => {
              this.count--;
              if (this.count === 0) {
                this.disabled = false;
                this.count = "";
                clearInterval(this.timer);
              }
            }, 1000);
          }
        });
      }
    },

    handleBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}
input,
button {
  border: 0 none;
  border-radius: 0px;
  outline: none;
}
/* header */
.header {
  min-width: 1260px;
  height: 80px;
  background: rgba(0, 137, 239, 1);
  position: relative;
}
.headerLogo {
  width: 115px;
  height: 40px;
  position: absolute;
  top: 20px;
  left: 50px;
}
.headerLine {
  display: block;
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 1);
  border-radius: 1px;
  position: absolute;
  top: 32px;
  left: 171px;
}
.header .headerTxt {
  width: 128px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  position: absolute;
  top: 29px;
  left: 178px;
}
/* openStep */
.openStep {
  width: 420px;
  height: 150px;
  background: white;
  color: #4a4a4a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 110px;
}
.openStep .circle {
  width: 51px;
  height: 51px;
  border-radius: 50%;
  background: rgb(224, 241, 253);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  /* opacity: 0.3; */
}

.openStep .circle1 {
  width: 43px;
  height: 43px;
  border-radius: 50%;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  background: rgb(163, 214, 251);
  line-height: 37px;
  text-align: center;
  line-height: 43px;
}
.openStep .check_circle .circle1 {
  background: linear-gradient(
    90deg,
    rgba(0, 137, 239, 1) 0%,
    rgba(0, 137, 239, 1) 100%
  );
}
.openStep .circleSmall {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 4px;
  background: rgba(219, 227, 233, 1);
  margin: 20px -8px;
  margin-top: -12px;
}
.openStep .stepTxt {
  width: 52px;
  height: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  color: rgba(153, 153, 153, 1);
  line-height: 18px;
  text-align: center;
}
.check_stepTxt {
  width: 52px;
  height: 18px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
  color: rgba(0, 137, 239, 1);
}
.five span {
  margin-left: 14px;
}
/* content */
.content {
  width: 1180px;
  min-height: 325px;
  height: calc(100vh - 290px);
  background: rgba(255, 255, 255, 1);
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 50px;
  text-align: center;
  line-height: calc(100vh - 290px);
  position: relative;
}

.right-btn {
  position: absolute;
  bottom: 20px;
  left: 340px;
  margin: 0 auto;
  width: 500px;
  height: 40px;
  background: rgba(0, 137, 239, 1);
  border-radius: 4px;
  span {
    span {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFangSC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
    }
  }
}
.right-btn:hover {
  background: rgba(0, 137, 239, 1);
}

/deep/ .el-radio:last-child {
  margin-right: 30px;
}
.tips {
  font-size: 13px;
  margin: 20px 0;
  color: #4a4a4a;
}
.rel {
  color: #4a4a4a;
  position: relative;
  .star {
    position: absolute;
    left: 90px;
    line-height: 30px;
  }
}
/deep/ .selected_button {
  width: 46px;
  margin-left: 10px;
  padding: 0 9px;
}
.box {
  display: inline-block;
  background: #00c600;
  border-radius: 50%;
  text-align: center;
  width: 65px;
  /* line-height: 65px; */
  height: 65px;
}
.rows {
  width: 420px;
  color: #949494;
  font-size: 14px;
}
.row1 {
  width: 100%;
  font-size: 14px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  .labe {
    // display: inline-block;
    // width: 84px;
    // text-align: right;
  }
  .myInput {
    width: 190px;
    box-sizing: border-box;
    /deep/.el-input__inner {
      height: 50px !important;
      border-radius: 4px 0 0px 4px !important;
    }
  }
  .mybtn1 {
    width: 150px;
    height: 50px;
    background: #fff;
    color: #949494;
    border: 1px solid #ccc;
    box-sizing: border-box;
    border-left: 0;
  }
}
.myInput1 {
  width: 420px;
  box-sizing: border-box;
  /deep/.el-input__inner {
    height: 50px !important;
    border-radius: 4px 0 0px 4px !important;
  }
}

.mybtn {
  width: 425px;
  height: 50px;
}
</style>
